export default {
    nodes: state => state.nodes,
    inputs: state => state.inputs,
    getModels: state => state.models,
    flowEndTrigger: state => state.flowEndTrigger
}